import { Component, OnInit } from '@angular/core';
import { ROUTES } from 'src/app/constants/Routes';


@Component({
  selector: 'app-hardware-page',
  templateUrl: './hardware-page.component.html',
  styleUrls: ['./hardware-page.component.scss'],
  standalone: false
})
export class HardwarePageComponent implements OnInit {
  Routes = ROUTES;
  activeSection = 'obd';

  heroCards = [
    {
      route: ROUTES.products_hardware_obd,
      icon: 'bx-plug',
      eyebrow: 'Plug-and-Play',
      title: 'OBD Smart Dongle',
      desc: 'Self-install telematics with diagnostics, GPS tracking, and cloud sync for everyday connected driving.',
      cta: 'Go to OBD '
    },
    {
      route: ROUTES.products_hardware_tcu,
      icon: 'bx-radio',
      eyebrow: 'Always-On',
      title: 'TCU Hardware',
      desc: 'Hardwired telematics control unit for secure, always-connected vehicle data, remote diagnostics, and OTA readiness.',
      cta: 'Go to TCU '
    },
    {
      route: ROUTES.products_hardware_dashcam,
      icon: 'bx-camera',
      eyebrow: 'Smart Safety',
      title: 'Camzo Dashcam',
      desc: 'Dual-camera dashcam with Wi-Fi app access, playback, trip reports, and contextual alerts.',
      cta: 'Go to Dashcam '
    },
    // {
    //   route: ROUTES.products_hardware_cluster,
    //   icon: 'bx-tachometer',
    //   eyebrow: 'Connected Display',
    //   title: 'Digital Cluster',
    //   desc: 'Retrofit digital instrument cluster with real-time telemetry, alerts, and connected in-vehicle experiences.',
    //   cta: 'Go to Cluster '
    // },
  ];

  sections = [
    { id: 'obd', label: 'OBD Dongle', icon: 'bx-plug' },
    { id: 'tcu', label: 'TCU', icon: 'bx-radio' },
    { id: 'camera', label: 'DashCam', icon: 'bx-camera' },
    { id: 'cluster', label: 'Digital Cluster', icon: 'bx-tachometer' },
  ];

  obdSpecs = [
    { label: 'Interface', val: 'OBD-II' },
    { label: 'Connectivity', val: '4G / BLE 5.0' },
    // { label: 'Battery Backup', val: '72 hrs' },
    { label: 'Data Rate', val: '1 Hz / 10 Hz' },
    { label: 'GPS Accuracy', val: '2.5m CEP' },
    { label: 'Self-Install', val: '< 60 sec' },
  ];

  obdFeatures = [
    { icon: 'bx-health', title: 'Vehicle Diagnostics', desc: 'Read DTCs and decode all OBD PIDs — battery, engine health, emissions, and more.' },
    { icon: 'bx-map-alt', title: 'GPS Tracking', desc: 'Real-time and historical trip tracking with route replay and geofencing.' },
    { icon: 'bx-user', title: 'Driver Scoring', desc: 'On-device event detection for harsh braking, speeding, and rapid acceleration.' },
    { icon: 'bx-cloud-upload', title: 'Cloud Sync', desc: 'Seamless data upload to Varroc Connect cloud even with intermittent connectivity.' },
  ];

  tcuSpecs = [
    { label: 'Interface', val: 'CAN Bus + OBD-II' },
    { label: 'Connectivity', val: '4G LTE Cat-4 + Wi-Fi + BT5' },
    { label: 'GNSS', val: 'GPS + GLONASS + BeiDou' },
    { label: 'I/O', val: '4 Digital IN / 2 Digital OUT' },
    { label: 'Power', val: '9-36V DC with backup battery' },
    { label: 'Mounting', val: 'Hardwired, DIN rail or surface' },
  ];

  tcuFeatures = [
    { icon: 'bx-radio', title: 'Always-On Connectivity', desc: 'Persistent telematics connection for live vehicle visibility, remote diagnostics, and data continuity.' },
    { icon: 'bx-map-pin', title: 'Multi-GNSS Tracking', desc: 'High-accuracy location tracking with GPS, GLONASS, and BeiDou support for fleet and enterprise use cases.' },
    { icon: 'bx-git-branch', title: 'I/O Expansion', desc: 'Supports digital inputs and outputs for ignition sensing, immobilizer logic, and auxiliary hardware integrations.' },
    { icon: 'bx-refresh', title: 'OTA Ready', desc: 'Built for firmware and configuration updates in the field without physical service intervention.' },
  ];



  camSpecs = [
    { label: 'Video', val: '2K Front + 1K Rear Dual Cam' },
    { label: 'Lens', val: '130° Wide Angle' },
    // { label: 'Storage', val: 'Up to 256GB microSD' },
    { label: 'Recording', val: 'Loop Recording (1 / 2 / 3 mins)' },
    { label: 'Power', val: 'Type-C USB ACC Power' },
    { label: 'Connectivity', val: 'Wi-Fi App Access' },
  ];

  camFeatures = [
    { icon: 'bx-video', title: 'Live View', desc: 'Watch real-time video in the Varroc Connect App.' },
    { icon: 'bx-download', title: 'Playback & Download', desc: 'Review footage and save important trip videos.' },
    { icon: 'bx-line-chart', title: 'Trip Reports', desc: 'Track driving behavior and trip-level insights.' },
    { icon: 'bx-bell', title: 'Contextual Alerts', desc: 'Get overspeed, braking, and impact alerts inside the app.' },
    { icon: 'bx-gift', title: 'Varroc Miles', desc: 'Earn safe-driving rewards through the connected app experience.' },
    { icon: 'bx-store-alt', title: 'E-commerce', desc: 'Access in-app offers and connected services.' },
  ];

  clusterSpecs = [
    { label: 'Display', val: '7in / 10in TFT LCD' },
    { label: 'Resolution', val: '1280 x 480' },
    { label: 'Interface', val: 'CAN + OBD + BLE' },
    { label: 'OS', val: 'Embedded Linux' },
    { label: 'Brightness', val: '1000 nits' },
    { label: 'Temp', val: '-20C to +70C' },
  ];

  clusterFeatures = [
    { icon: 'bx-tachometer', title: 'Real-Time Telemetry Display', desc: 'Speed, RPM, fuel, temperature, and battery status — all live from the vehicle CAN bus.' },
    { icon: 'bx-navigation', title: 'Integrated Navigation', desc: 'Turn-by-turn navigation with offline map support and points-of-interest overlay.' },
    { icon: 'bx-phone', title: 'AAOS & CarPlay Ready', desc: 'Android Automotive OS support for seamless app integration and voice control.' },
    { icon: 'bx-alert-circle', title: 'Contextual Alerts HMI', desc: 'Safety and maintenance alerts surfaced at the right moment — non-intrusive and driver-focused.' },
  ];

  ngOnInit() {}


  scrollTo(sectionId: string) {
    const el = document.getElementById(sectionId);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.activeSection = sectionId;
  }

  private setupIntersectionObserver() {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) this.activeSection = entry.target.id;
        });
      },
      { rootMargin: '-30% 0px -60% 0px' }
    );
    this.sections.forEach(s => {
      const el = document.getElementById(s.id);
      if (el) observer.observe(el);
    });
  }
}
